import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const TriangleExclamationIcon = ({
  color = 'black',
  width = 20,
  marginLeft,
  marginRight,
  containerSize,
  title = 'Error',
}: DefaultIconProps) => (
  <DefaultIconWrapper
    marginLeft={marginLeft}
    marginRight={marginRight}
    containerSize={containerSize}
    width={width}
    title={title}
  >
    <svg
      width={Number(width)}
      height={Number(width)}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.9201 17.9999H1.08007C0.26007 17.9999 -0.25993 17.1299 0.14007 16.4199L9.06007 0.549941C9.47007 -0.180059 10.5301 -0.180059 10.9401 0.549941L19.8601 16.4199C20.2601 17.1299 19.7401 17.9999 18.9201 17.9999ZM17.9801 16.74H2.02015C1.62015 16.74 1.37015 16.31 1.57015 15.97L9.55015 2.00005C9.75015 1.65005 10.2601 1.65005 10.4601 2.00005L18.4401 15.96C18.6401 16.31 18.3901 16.73 17.9901 16.73L17.9801 16.74ZM10.0001 12C10.4039 12 10.7364 11.6826 10.7551 11.2793L10.9538 6.99893C10.979 6.45489 10.5447 6 10.0001 6C9.4555 6 9.02124 6.45489 9.04649 6.99892L9.24515 11.2793C9.26387 11.6826 9.59634 12 10.0001 12ZM10.0057 15C10.6091 15 11.0001 14.5714 11.0001 14C10.9889 13.4066 10.5979 13 10.0057 13C9.41353 13 9.00012 13.4066 9.00012 14C9.00012 14.5714 9.40236 15 9.99454 15H10.0057Z"
        fill={getSemanticTextColor(color)}
      />
    </svg>
  </DefaultIconWrapper>
);
